import { DocumentLetterButton } from '../Components/DocumentLetterButton'
import { DOCUMENT_LETTER_PROVIDERS } from '../Contracts/ILetter'

import { canReadLetters } from './OwnerLettersTab'

export interface DocumentLetterActionProps {
    /** Ключ ресурсу картки документа: `Crm.ClientDocument`, `Crm.CarrierDocument` */
    documentResource: string | undefined
    /** Значення форми документа; без `uuid` (новий документ) листа ще не буде */
    record: { uuid?: unknown } | undefined
}

/**
 * Кнопка листа в картці документа (`SPEC-013` §9.5, §3.4): провайдер — за
 * ресурсом картки (`client_document` / `carrier_document`). Без збереженого
 * документа, без права на листи чи для чужого ресурсу — нічого.
 */
export const DocumentLetterAction = ({ documentResource, record }: DocumentLetterActionProps) => {
    const provider = documentResource !== undefined ? DOCUMENT_LETTER_PROVIDERS[documentResource] : undefined
    const uuid = typeof record?.uuid === 'string' && record.uuid !== '' ? record.uuid : null

    if (provider === undefined || uuid === null || !canReadLetters()) return null

    return <DocumentLetterButton provider={provider} documentUuid={uuid} />
}
